import React from "react";

function FormAttributeOptionEditor (props) {
  const faOptionInputId = `form_attribute_form_attribute_options_attributes_${props.index}_value`;
  const faOptionLabelId = `form_attribute_form_attribute_options_attributes_${props.index}_label`;

  return (
  <div className="form-attribute-option-container">
    <div className="option-value-input-container input-container">
      <label className="form-label font-weight-bold" htmlFor={faOptionInputId}>value:</label>
      <input type="text"
        className={`option-value-input form-control`}
        value={props.option.value} 
        name={`form_attribute[form_attribute_options_attributes][${props.index}][value]`} 
        id={faOptionInputId }
        required
        maxLength={100}
        onChange={(event) => {
          props.updateOptionValue(event.target.value, props.option);
        }} />
    </div>
    { props.form_attribute.option_has_label &&
      <div className="option-label-input-container input-container">
        <label className="form-label font-weight-bold" htmlFor={faOptionInputId}>label:</label>
        <input 
          type="text"
          className="option-label-input form-control"
          defaultValue={props.option.label}
          maxLength={100}
          name={`form_attribute[form_attribute_options_attributes][${props.index}][label]`} 
          id={faOptionLabelId} />
      </div>
    }
    
    { !!props.option.id ? 
      <input type="hidden" 
        value={props.option.id} 
        name={`form_attribute[form_attribute_options_attributes][${props.index}][id]`} 
        id={`form_attribute_form_attribute_options_attributes_${props.index}_id`} /> 
        : undefined 
    }
    <input type="hidden" 
      value={props.index+1} 
      name={`form_attribute[form_attribute_options_attributes][${props.index}][position]`} 
      id={`form_attribute_form_attribute_options_attributes_${props.index}_position`} />
    { props.option.delete ?
      <input 
        type="hidden" 
        value="true" 
        name={`form_attribute[form_attribute_options_attributes][${props.index}][_destroy]`} 
        id={`form_attribute_form_attribute_options_attributes_${props.index}__destroy`} />
      : undefined 
    }
  </div>);
};

export default FormAttributeOptionEditor;
